import { render, staticRenderFns } from "./GlobalSearchComponent.vue?vue&type=template&id=04477c35&scoped=true"
import script from "./GlobalSearchComponent.vue?vue&type=script&lang=js"
export * from "./GlobalSearchComponent.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchComponent.vue?vue&type=style&index=0&id=04477c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04477c35",
  null
  
)

export default component.exports